export const CART_RECOVERY_TTL = 24 * 60 * 60 * 1000;

export const cartRecoveryKey = ({ origin, api, tenant, outlet, user }) =>
  user && outlet ? `akas:pos-cart:v1:${[origin, api, tenant || origin, outlet, user].map(encodeURIComponent).join(":")}` : null;

const amount = (value) => Number.isFinite(Number(value)) && Number(value) >= 0 ? Number(value) : 0;

export const createCartSnapshot = (state, isDiscount, now = Date.now()) => ({
  version: 1,
  savedAt: now,
  pendingSubmission: false,
  customer_id: Number(state.customer_id) || 1,
  payment_method: ["cash", "qris", "transfer"].includes(state.payment_method) ? state.payment_method : "cash",
  discount: isDiscount ? amount(state.discount) : 0,
  tax: amount(state.tax),
  note: String(state.note || "").slice(0, 1000),
  details: (state.details || []).map((item) => ({
    product_id: Number(item.product_id),
    product_name: String(item.product_name || "Produk").slice(0, 200),
    qty: amount(item.qty),
    unit_price: amount(item.unit_price),
    note: String(item.note || "").slice(0, 300),
  })),
});

export const readCartSnapshot = (key, storage = window.localStorage, now = Date.now()) => {
  if (!key) return null;
  const raw = storage.getItem(key);
  if (!raw) return null;
  try {
    const value = JSON.parse(raw);
    const valid = value.version === 1 && Number.isFinite(value.savedAt)
      && value.savedAt <= now + 60000 && (value.pendingSubmission || now - value.savedAt <= CART_RECOVERY_TTL)
      && Array.isArray(value.details) && value.details.length > 0 && value.details.length <= 200
      && value.details.every((item) => Number.isInteger(item.product_id) && item.product_id > 0
        && Number.isFinite(item.qty) && item.qty > 0 && item.qty <= 1000000);
    if (valid) return { ...createCartSnapshot(value, true, value.savedAt), pendingSubmission: Boolean(value.pendingSubmission) };
  } catch { /* Data browser yang rusak tidak digunakan sebagai transaksi. */ }
  storage.removeItem(key);
  return null;
};
